class Form {
    constructor() {
        if (jQuery('.inquiry-form').length) {
            this.initPickADay();
            this.initChildAgeFields();
            this.initAlternativeRoomField();
            this.initSortCountries();
        }
        this.inputWithPlaceholder();
        this.preventMultipleSubmissions();
    }

    initPickADay() {
        var getVar = function (string) {
            var regexp = /{([^)]+)}/;
            var matches = regexp.exec(string);
            return matches != null ? matches[1] : null;
        };

        var getDateValue = function (value) {
            var relVar = getVar(value);

            if (relVar != null) {
                var relation = value.substr(relVar.length + 2);
                var relDateString = jQuery('*[name*="[' + relVar + '][date]_submit"]').val();
                var relDate;
                if (relDateString.length == 0) {
                    relDate = new Date();
                } else {
                    relDate = new Date(relDateString);
                }

                var relCalc = relDate.getDate() + relation;
                relDate.setDate(eval(relCalc));
                var today = new Date();
                var timeDiff = Math.abs(relDate.getTime() - today.getTime());
                var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                value = diffDays;
            }

            return value;
        };

        jQuery('.input--datepicker .input__field').pickadate({
            onOpen: function () {
                var min = this.$node.data('mindate');
                var max = this.$node.data('maxdate');
                var disableddates = this.$node.data('disableddates');
                var enableddates = this.$node.data('enableddates');

                if (typeof min !== 'undefined') {
                    this.set('min', getDateValue(min));
                }

                if (typeof max !== 'undefined') {
                    this.set('max', getDateValue(max));
                }

                if (typeof disableddates !== 'undefined') {
                    this.set('disable', disableddates);
                }

                if (typeof enableddates !== 'undefined') {
                    var today = new Date();
                    if (getVar(min) == null) {
                        for (var i = 0; i <= enableddates.length; i++) {
                            var curr = new Date(
                                enableddates[i].from[0],
                                enableddates[i].from[1],
                                enableddates[i].from[2]
                            );
                            if (curr.getTime() >= today.getTime()) {
                                break;
                            }
                        }
                        this.set('min', curr);
                    }

                    this.set('disable', true);
                    this.set('disable', enableddates);
                }
            },

            onClose: function () {
                this.$node.toggleClass('input__field--not-empty', !!this.$node.val());
            },
        });
    }

    inputWithPlaceholder() {
        //outsource to seperate module
        jQuery('.input--with-placeholder .input__field').each(function () {
            jQuery(this).toggleClass('input__field--not-empty', !!this.value);
        });

        //set "notEmpty class on blur
        jQuery('.input--with-placeholder .input__field').blur(function () {
            jQuery(this).toggleClass('input__field--not-empty', !!this.value);
        });
    }

    /**
     * Adds fields for the ages for the children according to the
     * selected number of children.
     *
     * First we clean all the excess fields (hide and set to empty) and afterwards
     * we check if we have to add more fields to the form.
     */
    initChildAgeFields() {
        function updateChildAgeFields() {
            var childrenQuantity = jQuery('.input--children-quantity').val();

            var removeFields = function () {
                if (childrenQuantity === 0) {
                    jQuery('.childage').slideUp();
                    jQuery('.childage').addClass('is-hidden');
                    setEmpty(jQuery('.childage input'));
                    return;
                }

                //check how many fields are currently visible
                var fieldAmount = jQuery('.childage').filter(function () {
                    return jQuery(this).css('display') !== 'none';
                }).length;

                for (let i = parseInt(fieldAmount); i > childrenQuantity; i--) {
                    jQuery('.childage--' + i).slideUp();
                    jQuery('.childage--' + i).addClass('is-hidden');
                    setEmpty(jQuery('.childage--' + i).children('input'));
                }

                function setEmpty($element) {
                    $element.val('');
                    $element.removeAttr('value');
                    $element.removeClass('input__field--not-empty');
                    $element.prop('required', false);
                }
            };

            var addFields = function () {
                if (childrenQuantity > 0) {
                    for (let i = 0; i <= childrenQuantity; i++) {
                        jQuery('.childage--' + i).slideDown();
                        jQuery('.childage--' + i).removeClass('is-hidden');
                        jQuery('.childage--' + i)
                            .children('input')
                            .prop('required', true);
                    }
                }
            };
            removeFields();
            addFields();
        }

        updateChildAgeFields();

        jQuery('.input--children-quantity').change(updateChildAgeFields);
    }

    /**
     * Show alternative room field and fill with valid options
     */
    initAlternativeRoomField() {
        const roomSelectField = jQuery('#inquiryForm-room');
        const alternativeRoomSelectField = jQuery('#inquiryForm-alternativeRoom');
        const roomSelectFieldInitialOptions = jQuery('#inquiryForm-room option');
        setAlternativeRoomOptions();

        roomSelectField.change(function () {
            setAlternativeRoomOptions();
        });

        function setAlternativeRoomOptions() {
            let value = roomSelectField.val();
            if (value) {
                // remove same room from alternative room selection
                alternativeRoomSelectField.empty();
                let alternativeRoomSelectFieldInitialOptions = roomSelectFieldInitialOptions.clone();
                alternativeRoomSelectFieldInitialOptions = alternativeRoomSelectFieldInitialOptions.filter(function (
                    index,
                    option
                ) {
                    return option.value !== value;
                });
                alternativeRoomSelectField.append(alternativeRoomSelectFieldInitialOptions);
                alternativeRoomSelectField.val('');
                alternativeRoomSelectField.parents('.js-alternative-room-container').removeClass('hidden');
            } else {
                alternativeRoomSelectField.parents('.js-alternative-room-container').addClass('hidden');
                alternativeRoomSelectField.empty();
            }
        }
    }

    /**
     * Sort Countries alphabetically
     */
    initSortCountries() {
        const selectField = document.getElementById('inquiryForm-country');

        if (selectField) {
            var countryOptionArrayTop = [];
            var countryOptionArray = [];

            [...selectField.getElementsByTagName('option')].forEach((countryOption) => {
                if (
                    countryOption.value != 'de' &&
                    countryOption.value != 'at' &&
                    countryOption.value != 'ch' &&
                    countryOption.value != 'gb' &&
                    countryOption.value != 'us'
                ) {
                    countryOptionArray.push([countryOption.text, countryOption.value]);
                } else {
                    countryOptionArrayTop.push([countryOption.text, countryOption.value]);
                }
                countryOption.remove();
            });
            countryOptionArray = countryOptionArrayTop.concat(countryOptionArray.sort(new Intl.Collator('de').compare));

            for (var i = 0; countryOptionArray.length > i; i++) {
                selectField.add(
                    new Option(countryOptionArray[i][0], countryOptionArray[i][1] + ' - ' + countryOptionArray[i][0])
                );

                if (i === 4) {
                    var disabledOption = new Option('-------------', '');
                    disabledOption.disabled = true;
                    selectField.add(disabledOption);
                }
            }
        }
    }

    preventMultipleSubmissions() {
        document.querySelectorAll('form.form').forEach((form) => {
            if (form instanceof HTMLFormElement) {
                form.addEventListener('submit', (event) => {
                    if (form.hasAttribute('data-submitting')) {
                        event.preventDefault();

                        return false;
                    }
                    form.setAttribute('data-submitting', '');
                });
            }
        });
    }
}

new Form();
